<template>
  <ButtonSquare
    :title="$t('general__view__vector-layer')"
    :imgSource="require('@/assets/icon-maps.svg')"
    size="large"
    :activeState="activeState"
    :hoverButtons="hoverButtons"
    :activeHoverButtonValue="currentMapVectorTileId"
    :showLoadingSpinner="mapVectorTileState === 'loading'"
    @clicked="toggle"
    @onHoverButtonClick="changeVectorTile"
    @mouseover="$emit('MapVectorTileButtonHovered')"
  />
</template>

<script>
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { mapMutations, mapState } from 'vuex'
import { MAPVIEW_PREFIX } from '@/store/module-prefixes'
import { SET_CURRENT_MAP_VECTOR_TILE_ID, SET_MAP_VECTOR_TILE_STATE } from '@/store/mutation-types'

export default {
  name: 'MapVectorTileButton',
  components: {
    ButtonSquare
  },
  emits: ['MapVectorTileButtonHovered'],
  data() {
    return {
      hoverButtons: [],
      vectorTiles: [{ title: 'Umeå Energi – Ledningar', id: 'vektorlager_1' }]
    }
  },
  computed: {
    ...mapState(MAPVIEW_PREFIX, {
      selectedRealEstate: (state) => state.selectedRealEstate,
      currentMapVectorTileId: (state) => state.currentMapVectorTileId,
      mapVectorTileState: (state) => state.mapVectorTileState
    }),
    activeState() {
      if (!this.hoverButtons.length) return 'deactivated'
      return this.mapVectorTileState !== 'hidden' ? 'active' : 'inactive'
    }
  },
  watch: {
    selectedRealEstate: {
      immediate: true,
      handler() {
        this.setMapVectorTileState('hidden')
        this.hoverButtons = this.getHoverButtons()
        if (this.hoverButtons.length) this.setCurrentMapVectorTileId(this.hoverButtons[0].emit)
      }
    }
  },
  methods: {
    ...mapMutations(MAPVIEW_PREFIX, {
      setCurrentMapVectorTileId: SET_CURRENT_MAP_VECTOR_TILE_ID,
      setMapVectorTileState: SET_MAP_VECTOR_TILE_STATE
    }),
    getHoverButtons() {
      const hoverButtons = []
      if (this.selectedRealEstate == null) return hoverButtons
      // Frontend demo for AH Umeå, currently real estate id 727903614376603648 on both dev and live
      if (this.selectedRealEstate.id === '727903614376603648')
        this.vectorTiles.forEach((vectorTile) => {
          hoverButtons.push({ title: vectorTile.title, emit: vectorTile.id })
        })
      return hoverButtons
    },
    changeVectorTile(id) {
      if (id === this.currentMapVectorTileId && this.mapVectorTileState === 'visible') return
      this.setCurrentMapVectorTileId(id)
      this.setMapVectorTileState('loading')
    },
    toggle() {
      if (this.activeState === 'deactivated') return
      if (this.hoverButtons.length && !this.currentMapVectorTileId)
        this.setCurrentMapVectorTileId(this.hoverButtons[0].emit)
      const newMapVectorTileState = this.mapVectorTileState === 'hidden' ? 'loading' : 'hidden'
      this.setMapVectorTileState(newMapVectorTileState)
    }
  }
}
</script>
